import * as amplitude from '@amplitude/analytics-browser'

type EventFunction<T> = (properties: T) => void

function createEvent<T>(name: string): EventFunction<T> {
  return function (properties: T): void {
    amplitude.track(name, {
      ...properties,
      'Page URL': window.location.href.split('?')[0],
    })
  }
}

type StarClickedProperties = {
  id: string
  fid: string
  component: string
}

const createStarClickedEvent = createEvent<StarClickedProperties>

export const addModelStarClicked = createStarClickedEvent(
  'Add Model Star Clicked',
)

export const removeModelStarClicked = createStarClickedEvent(
  'Remove Model Star Clicked',
)

export const addTrendStarClicked = createStarClickedEvent(
  'Add Trend Star Clicked',
)

export const removeTrendStarClicked = createStarClickedEvent(
  'Remove Trend Star Clicked',
)

type ModelProperties = {
  id: string
  type: string
}

type ModelPageViewedProperties = ModelProperties & {
  state: string
}

export const modelPageViewed =
  createEvent<ModelPageViewedProperties>('Model Page Viewed')
export const modelCreated = createEvent<ModelProperties>('Model Created')

type ModelCopiedProperties = ModelProperties & {
  source_id: string
}

export const modelCopied = createEvent<ModelCopiedProperties>('Model Copied')

type ModelTrainedProperties = ModelProperties & {
  configurationName?: string
}

export const modelTrained = createEvent<ModelTrainedProperties>('Model Trained')
export const modelActivated = createEvent<ModelProperties>('Model Activated')
export const modelDeactivated =
  createEvent<ModelProperties>('Model Deactivated')
export const modelDeleted = createEvent<ModelProperties>('Model Deleted')
export const modelArchived = createEvent<ModelProperties>('Model Archived')
